import { Component, Injector, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseComponent } from '../common/BaseComponent';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-pki-error',
    templateUrl: './pki-error.component.html'
})
export class PkiErrorComponent extends BaseComponent implements OnInit {
    menuType: string;
    errorCode: string;
    errorMessage: string;
    appErrorPrefix: string = "bss.pki.error";
    private languageChangeSubs: Subscription;
    constructor(private cookieService: CookieService,
        injector: Injector,) {
        super(injector);
    }

    ngOnInit(): void {
        const sessionUser = sessionStorage.getItem("user");
        this.menuType = (sessionUser != null) ? "secure" : "public";
        this.subscribeToLanguageChange();
    }
    private subscribeToLanguageChange(): void {
        this.languageChangeSubs = this.translator.onLangChange.subscribe(
          () => {
            this.showErrorMessage();
          }
        );
      }
    showErrorMessage(){
        if (this.translator && this.translator.instant) {
            this.route.queryParams.subscribe(params => {
                this.errorCode = params['error_code'];
                // console.log(this.errorCode);
                if (!this.errorCode) {
                    this.errorMessage = this.translator.instant("bss.pki.error.default");
                }
                let translatedError = this.translator.instant(this.appErrorPrefix + "." + this.errorCode);
                if (translatedError === (this.appErrorPrefix + "." + this.errorCode)) {
                    this.errorMessage = this.translator.instant("bss.pki.error.default");
                } else {
                    this.errorMessage = translatedError;
                    // console.log(this.errorMessage);
                }
            });
        }
    }

}

